import selectLoadmore from './select-loadmore';
import dragDialog from './drag-dialog';
import permission from './permission';

const install = function (Vue) {
  Vue.directive('select-loadmore', selectLoadmore);
  Vue.directive('drag-dialog', dragDialog);
  Vue.directive('permission', permission);
};

export default install;
